module.exports = __webpack_public_path__ + "static/media/service_brunch-back.fa220772.jpg";